import { v4 as uuidv4 } from 'uuid';

export const SuaChuaArr = [
    {
        id: uuidv4(),
        amount: 1,
        img: 'https://tocotocotea.com/wp-content/uploads/2022/10/sua-chua-man-hat-sen-.png',
        name: 'Trà Xoài Bưởi Hồng Kem Phô Mai',
        originPrice: '40000',
        salePrice: '28000',
    },
    {
        id: uuidv4(),
        amount: 1,
        img: 'https://tocotocotea.com/wp-content/uploads/2021/05/sua-chua-dau-tam-hoang-kim.png',
        name: 'Trà Xoài Bưởi Hồng Kem Phô Mai',
        originPrice: '40000',
        salePrice: '28000',
    },
];
